import { render } from "./manageAdd.vue?vue&type=template&id=5f659c91&scoped=true"
import script from "./manageAdd.vue?vue&type=script&lang=js"
export * from "./manageAdd.vue?vue&type=script&lang=js"

import "./manageAdd.vue?vue&type=style&index=0&id=5f659c91&lang=scss&scoped=true"
import "./manageAdd.vue?vue&type=style&index=1&id=5f659c91&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f659c91"]])

export default __exports__